import React from "react";
import { Link } from "react-router-dom";

const Navbar = () => {
  return (
    <nav style={{ padding: "10px", background: "#44e5fd", textAlign: "center" }}>
      <Link to="/" style={{ margin: "0 15px", textDecoration: "none", color: "#082326" }}>
        Home
      </Link>
      <Link to="/about" style={{ margin: "0 15px", textDecoration: "none", color: "#082326" }}>
        About
      </Link>
    </nav>
  );
};

export default Navbar;